import axios from 'axios';
import { isTeachers } from 'utils/checkUrl';
import resolvePath from 'utils/resolvePath';
// Action
const GET_EVALUATIONS_REQUEST = 'evaluations/getEvaluationsRequest';
const GET_EVALUATIONS_SUCCESS = 'evaluations/getEvaluationsSuccess';
const GET_EVALUATIONS_FAILURE = 'evaluations/getEvaluationsFailure';
const CLEAR_EVALUATIONS = 'evaluations/clearEvaluations';
export const getEvaluationsRequest = () => {
    return {
        type: GET_EVALUATIONS_REQUEST,
    };
};
export const getEvaluationsSuccess = (response) => {
    return {
        payload: {
            response,
        },
        type: GET_EVALUATIONS_SUCCESS,
    };
};
export const getEvaluationsFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_EVALUATIONS_FAILURE,
    };
};
export const getEvaluations = (authToken, id) => (dispatch) => {
    dispatch(getEvaluationsRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    const partnerType = isTeachers() ? 'students' : 'teachers';
    return axios
        .get(`${resolvePath.api(`${partnerType}/${id}/evaluations`)}?`, config)
        .then((response) => dispatch(getEvaluationsSuccess(response.data)))
        .catch((error) => {
        dispatch(getEvaluationsFailure(error));
        throw error;
    });
};
export const clearEvaluations = () => {
    return {
        type: CLEAR_EVALUATIONS,
    };
};
const initialState = {
    data: null,
    error: null,
    isFetching: false,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case GET_EVALUATIONS_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_EVALUATIONS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { data: Object.assign({}, action.payload.response), isFetching: false });
        }
        case GET_EVALUATIONS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case CLEAR_EVALUATIONS: {
            return Object.assign(Object.assign({}, state), { data: null, isFetching: false });
        }
        default: {
            return state;
        }
    }
};
